import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import React from 'react';
import { spanTsx } from './helpers';

export const AccordionLegend: React.FC = () => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<GridExpandMoreIcon />}
        aria-controls='panel1-content'
        id='panel1-header'
      >
        Legende
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ marginLeft: 2 }}>{spanTsx('#c8c8c8', '#fff')} Entwurf</Box>
          <Box sx={{ marginLeft: 2 }}>{spanTsx('#f2f299', '#fff')} Laufend</Box>
          <Box sx={{ marginLeft: 2 }}>{spanTsx('#c9d8f8', '#fff')} Inaktiv</Box>
          <Box sx={{ marginLeft: 2 }}>
            {spanTsx('#f5cfb4', '#fff')} Storniert
          </Box>
          <Box sx={{ marginLeft: 2 }}>
            {spanTsx('#19a315', '#fff')} Abgeschlossen
          </Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ marginLeft: 2 }}>
            {spanTsx('#fff', '#808080')} Datenerfassung
          </Box>
          <Box sx={{ marginLeft: 2 }}>{spanTsx('#fff', '#0f1b73')} Entwurf</Box>
          <Box sx={{ marginLeft: 2 }}>
            {spanTsx('#fff', '#9a9c14')} Abwicklung
          </Box>
          <Box sx={{ marginLeft: 2 }}>
            {spanTsx('#fff', '#14660d')} Abschluss
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
